import axios from '../../api/index.js';

//查询新闻中心列表
export let getNewsList = (params) => {
    return axios.post(`/client/wm_news/list`, params);
};

//查询新闻中心详情
export let getNewsContent = (params) => {
    return axios.get(`/client/wm_news/${params}`);
};

//获取企业证书公示期列表
export let getNewsCertList = (params) => {
    return axios.post(`/client/wm_ent_publicity_cert/list`, params);
};

//证书公示
export let getEntNewsList = (params) => {
    return axios.post(`/client/wm_news/entCertList`,params);
};




// WEBPACK FOOTER //
// ./src/api/wm_news/news.js